import managePage from './user/profile/manage';
import editProfile from './user/profile/edit';
import changePassword from './user/profile/change-password';
import resettingPassword from './user/profile/resetting-password';
import modalUser from './user/modals/modal-user';

export default function () {
  managePage();
  editProfile();
  changePassword();
  resettingPassword();

  if (
    document.querySelector('header')
    && document.querySelector('.modal-user')
  ) {
    modalUser('.modal-user');
  }

  if (document.getElementById('lead-modals')) {
    import(
      /* webpackChunkName: "logged-leads" */ './user/leads/leads-modals'
    ).then(({ default: leads }) => {
      leads();
    });
  }

  if (document.getElementById('user-profile-team')) {
    import('./user/profile/organization/main');
  }
}
